import React, {useState} from 'react';
import Link from "next/link";
import styled from "styled-components";
import CitiesModal from "@molecules/modals/cities";
import {citiesSelection} from "@hooks/cities";
import Icon from "@atoms/icon";
import ChevronLeftIcon from "@icons/chevron-left.svg";
import IranIcon from "@icons/cities/iran.svg";
import MashhadIcon from "@icons/cities/mashhad.svg";
import ShomalIcon from "@icons/cities/shomal.svg";
import TehranIcon from "@icons/cities/tehran.svg";

const WelcomeSelectCities = () => {
    const [showCitiesModal, setShowCitiesModal] = useState(false);
    const [cities, setCities] = useState([]);

    const CitiesTileItems = [
        {name: 'تهران', icon: <TehranIcon/>},
        {name: 'مشهد', icon: <MashhadIcon/>},
        {name: 'شمال', icon: <ShomalIcon/>},
    ];

    const handleCitiesModal = async () => {
        setShowCitiesModal(true);
        if (cities.length < 1) {
            await citiesSelection().then((result) => {
                if (result) {
                    setCities(result.options);
                }
            })
        }
    };

    return (
        <React.Fragment>
            <h2 className="h1">شهر مورد‌نظرتون رو انتخاب کنید</h2>

            <div className="row">
                {
                    CitiesTileItems.map((city, key) =>
                        <div className="col-6 col-lg-3 mt-16" key={key}>

                            <Link href="/properties" as={('شمال' === city.name) ? 'املاک-' + city.name + '/خرید-فروش-ویلا' : 'املاک-' + city.name}>
                                <a>
                                    <CitiesTile className="border border-gray200 rounded-16 d-flex flex-column align-items-center">
                                        <Icon className="city-icon">{city.icon}</Icon>
                                        <div className="d-flex align-items-center mt-16 mt-lg-24">
                                            <h3 className="h2 ml-8">{city.name}</h3>
                                            <Icon width="14" height="14" className="arrow-left"><ChevronLeftIcon/></Icon>
                                        </div>
                                    </CitiesTile>
                                </a>
                            </Link>

                        </div>
                    )
                }

                <div className="col-6 col-lg-3 mt-16">
                    <CitiesTile onClick={() => handleCitiesModal()} className="border border-gray200 rounded-16 d-flex flex-column align-items-center cursor-pointer">
                        <Icon className="city-icon"><IranIcon/></Icon>
                        <div className="d-flex align-items-center mt-16 mt-lg-24">
                            <h3 className="h2 ml-8">سایر شهرها</h3>
                            <Icon width="14" height="14" className="arrow-left"><ChevronLeftIcon/></Icon>
                        </div>
                    </CitiesTile>
                </div>

                <CitiesModal cities={cities} show={showCitiesModal} setShow={setShowCitiesModal}/>
            </div>
        </React.Fragment>
    );
};

export default React.memo(WelcomeSelectCities);

// styles

const CitiesTile = styled.div`
    padding: 56px 0;
    
    h3 {
        font-weight: 500;
    }
    
    .city-icon {
        height: 105px;
    }
    
    &:hover {
        background-color: ${props => props.theme.primary} !important;
        color: #ffffff;
        
        .city-icon svg {
            path {
                fill: #ffffff;
            }
        }
        
        .arrow-left svg {
            path {
                stroke: #ffffff;
            }
        }
    }
    
    @media(max-width: ${props => props.theme.screenXsMax}) {
        padding: 24px 0;
        
        .city-icon {
            height: 64px;
        }
        
        h3 {
            font-size: 15px;
            font-weight: normal;
        }
        
        .arrow-left {
             width: 6px;
             max-width: 6px;
             min-width: 6px;
        }
    }
`;
